import {GetServicePointsUfsParams} from 'domain/usecases/private/service-points/get-service-points-ufs';
import {makeGetServicePointsUfs} from 'main/factories/usecases/private/service-points/get-service-points-ufs-factory';

export async function getServicePointsUfs(params: GetServicePointsUfsParams) {
	const response = await makeGetServicePointsUfs().get(params);

	if (!response) {
		return {
			ds_origem: params.origem,
			ufs: [],
		};
	}

	return response;
}
